// export default {LotDetail as BatchesDetail} from './LotDetail'
import LotDetail from './LotDetail'
export default LotDetail
